import { getAxiosClient, makeApiRequest } from '@givelify/utils';
import { Officer } from 'store/settings/officers/types';

export const getOfficers = (doneeId: number) => {
    const httpRequest = getAxiosClient().get(`/donees/${doneeId}/users`);
    const result = makeApiRequest<{ data: Officer[] }>(httpRequest);
    return result;
};
